import { useLocalStorage } from "usehooks-ts";

export const views = {
  noChronicDiseases: "noChronicDiseases",
  general: "general",
};

export const useView = (storageKey) => {
  return useLocalStorage(storageKey, {
    name: views.noChronicDiseases,
    cdmId: null,
  });
};
